<!-- 由 suu 创建于 2021-11-09 星期二 -->
<template>
  <div
    class="app-download"
    :class="{ 'app-download-lrt': isLrtTime }"
    v-pageBuried
    :data-page-buried="bgText"
  >
    <van-overlay
      :show="showOpen && !isMini"
      @click="showOpen = false"
      z-index="99"
      :lock-scroll="false"
    >
      <img
        class="ad-open"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-open"
        alt=""
      />
    </van-overlay>
    <div class="image-container">
      <img class="ad-bg" :src="bgImg" alt="" />
      <div class="ad-tips" :class="{ 'ad-tips-jianmeng': sfrom == 'jianmeng' }">
        <div class="t-btn user-btn" @click="toUrl(0)">应用权限</div>
        <div class="t-line"></div>
        <div class="t-btn user-btn" @click="toUrl(1)">隐私协议</div>
      </div>
    </div>
    <div class="ad-btn ad-btn-have"
      >已下载直接打开<WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp
    ></div>
    <!-- 下载 -->
    <!-- <div
        class="ad-btn user-btn"
        @click="downloadApp"
        ref="copy"
        :data-clipboard-text="filterText"
        alt="下载按钮"
      > -->
    <img
      class="ad-btn ad-btn-img user-btn"
      v-if="moreInfo === 'ann2024'"
      @click="downloadApp"
      v-clickBuried
      :data-click-buried="clickText"
      src="https://cdnvue.gymcity.com.cn/uploads/ann-2024-app-btn"
      alt=""
    />
    <div
      v-else
      class="ad-btn user-btn"
      @click="downloadApp"
      alt="下载按钮"
      v-clickBuried
      :data-click-buried="clickText"
    >
      <img
        :src="
          isAndroid
            ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-icon-android'
            : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-icon-ios'
        "
        alt=""
      />
      {{
        sfrom == 'JMHY_TZC'
          ? '下载APP 绑定体脂秤'
          : isLrtTime
          ? '前往betterWE星球APP'
          : '下载 betterWE星球APP'
      }}
    </div>
    <!-- 已下载 直接打开按钮 -->
    <!-- <div class="ad-float" v-if="showFloat">
        已下载APP？
        <a
          :href="
            isAndroid
              ? `betterwe://btwx.gymcity.com.cn/?path=/home`
              : `betterwe://btwx.gymcity.com.cn/?path=/home`
          "
          >点击打开</a
        >
      </div> -->
  </div>
</template>

<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import BetterweWxApi from '@/components/wx/control.js'
// import Clipboard from 'clipboard'
import Vue from 'vue'
import { Overlay } from 'vant'
Vue.use(Overlay)
export default {
  name: 'app-download',
  components: { WxOpenLaunchApp },

  props: {},

  data() {
    return {
      showFloat: false,
      showOpen: false, // 显示引导浏览器中打开
      clipboard: null,
      isWeiXin: false, // 是否是微信环境
      isMini: false, // 是否是小程序环境
      isAndroid: false,
      isIOS: false,
      inviteCode:
        this.$route.query.invitedCode || this.$route.query.inviteCode || '',
      moreInfo: this.$route.query.moreInfo, // 更多信息 标记
      // toAppPath值 在后台APP链接生成器配置 从浏览器启动APP  betterwe://btwx.gymcity.com.cn/?newPath=后面的部分
      // https://admin.betterwestar.com/admin/AppRouter/index
      toAppPath: this.$route.query.toAppPath || '', // 需要跳转的app路由
      extinfo: this.$route.query.toAppPath || '/home' // 扩展参数
    }
  },

  computed: {
    // 是否是李若彤
    isLrtTime() {
      return (
        new Date() < new Date('2025/09/01') && this.sfrom === 'JM_gongzhonghao'
      )
    },
    // 页面背景图
    bgImg() {
      let imageObj = {
        jianmeng:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app-down-bg-629-jm?v=2',
        BAOGUOKA:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7fd2d43afd3a8ba87594ce91e1639c53.png',
        BAOGUOKA2:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7fd2d43afd3a8ba87594ce91e1639c53.png',
        XIYOUZHI:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7fd2d43afd3a8ba87594ce91e1639c53.png',
        default: 'https://cdnvue.gymcity.com.cn/uploads/app-down-bg-default',
        JMCS_GWD:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bcc235a9dc129a5fe5b77230c9cfd77c.jpg',
        JMHY_TZC:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5a897762ea909c088ed59e03316b1d3a.png',
        JZY_4ZNZH:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bb6965ccb0aec5bdea11ca5f9d651224.png',
        JM_gongzhonghao:
          'https://cdnvue.gymcity.com.cn/uploads/app-down-bg-JM_gongzhonghao'
      }
      if (this.isLrtTime) {
        imageObj.JM_gongzhonghao =
          'https://cdnvue.gymcity.com.cn/uploads/appdown-lrt-bg'
      }
      if (this.moreInfo === 'ann2024') {
        return 'https://cdnvue.gymcity.com.cn/uploads/ann-2024-bg-app'
      }
      return imageObj[this.sfrom] || imageObj.default
    },
    // 营养师评选活动 粘贴板文案
    filterText() {
      return this.inviteCode && `inviteCode{#}${this.inviteCode}{#}end`
    },
    // curSystemBtn() {
    //   if (this.isAndroid) {
    //     return 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app-down-android'
    //   }
    //   return 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app-down-ios'
    // },
    sfrom() {
      return this.$route.query.sfrom || 'default'
    },
    androidDownloadUrl() {
      let channel = this.$route.query.sfrom || 'BETTERWE'
      return (
        'https://gymvue.gymcity.com.cn/betterWE_channel_' +
        channel +
        '.apk'
      )
    },
    iosAppstoreUrl() {
      let defaultUrl = 'https://apps.apple.com/cn/app/id1578889450'
      let channelUrl =
        'https://apps.apple.com/app/apple-store/id1578889450?pt=123007243&ct=' +
        this.sfrom +
        '&mt=8'
      return this.$route.query.sfrom ? channelUrl : defaultUrl
    },
    bgText() {
      let sfrom = this.$route.query.sfrom
      return 'BG_APP_DOWNLOAD' + (sfrom ? '_' + sfrom : '')
    },
    clickText() {
      let sfrom = this.$route.query.sfrom
      return 'CLICK_APP_DOWNLOAD' + (sfrom ? '_' + sfrom : '')
    }
  },

  watch: {},

  created() {
    this.checkPhone()
    this.isWeiXin =
      navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
        ? true
        : false
    try {
      wx.miniProgram.getEnv((res) => {
        this.isMini = res.miniprogram ? true : false
      })
    } catch (error) {
      this.isMini = false
    }
    // window.location.hash = '#/app-download?downloading' // 改变hash，便于浏览器打开时直接跳转AppStore
    setTimeout(() => {
      this.setShare()
    }, 800)
  },

  mounted() {
    // 友盟埋点
    this.$buryPoint('APP_DOWNLOAD_SHOW', {
      from: this.sfrom
    })
    // 微信环境则提示 右上角浏览器打开
    if (this.isWeiXin) {
      console.log('to', this.toAppPath)
      // this.$messagebox.alert('请点击右上角选择在浏览器中打开')
      // if (this.isIOS && !this.toAppPath) {
      //   // ios 不需要跳转APP指定页面的 不显示遮罩 在微信浏览器 有些版本IOS会拉起 询问是否打开APPStore 直接进入AppStore
      //   window.location.href = this.iosAppstoreUrl
      // } else {
      //   this.showOpen = true // 微信环境则提示 右上角浏览器打开
      // }
      // this.downloadApp();
    } else {
      // 在手机其他浏览器环境 可以拉起已安装的betterWE APP
      // 自动跳转
      // if (!sessionStorage['tryOpenApp']) {
      //   sessionStorage['tryOpenApp'] = 1
      //   const cur = location.href
      //   setTimeout(() => {
      //     location.href = cur
      //   }, 1000)
      // }
      // location.href = `https://btwx.gymcity.com.cn/?path=/home&inviteCode=${this.inviteCode}`
      if (this.moreInfo == 'ann2024') {
        // 2024年度报告
        location.href = `betterwe://btwx.gymcity.com.cn/?newPath=/web?url=https%3A%2F%2Fbtvue.gymcity.com.cn%2Factivity%2F2024%2Fcoach-flower-giving-activity`
        // location.href = `betterwe://btwx.gymcity.com.cn/?newPath=/web?url=https%3A%2F%2F${
        //   window.online ? 'btvue' : 'tbtvue'
        // }.gymcity.com.cn%2Factivity%2F2024%2Fcoach-flower-giving-activity`
      } else if (this.moreInfo == 'jmCoachMainPage') {
        // 公众号教练主页 案例 口碑点击
        // location.href = `betterwe://btwx.gymcity.com.cn/?newPath=%2FjMAppointment%3FisLogin%3D1%26appLinkUseTypeId%3D4%26appRouterPagesId%3D33%26appRouterId%3D253`
        location.href = `betterwe://btwx.gymcity.com.cn/?newPath=%2Fweb%3Furl%3Dhttps%253A%252F%252F${
          window.online ? 'btvue' : 'tbtvue'
        }.gymcity.com.cn%252Ftrans-coach-course%253Fcoachid%253D${
          this.$route.query.coachid
        }%26title%3D%25E9%25A2%2584%25E7%25BA%25A6%25E8%25AF%25BE%25E7%25A8%258B%26isShowTitle%3Dtrue%26isLogin%3D1%26isJM%3D1%26isAddToken%3Dfalse`
      } else if (this.moreInfo == 'coachFlag') {
        location.href = `betterwe://btwx.gymcity.com.cn/?newPath=%2Fweb%3Furl%3Dhttps%253A%252F%252F${
          window.online ? 'vue' : 'test'
        }.gymcity.com.cn%252F%2523%252Factivity-2025-11-27-flag%26title%3DbetterWE%26isShowTitle%3Dfalse%26isLogin%3D1%26isJM%3D1%26isAddToken%3Dfalse%26appLinkUseTypeId%3D4%26appRouterPagesId%3D69%26appRouterId%3D592`
      } else if (this.toAppPath) {
        // 跳转APP指定页面 浏览器会自动解码一次所以这里需要再encodeURIComponent编码
        console.log('toAppPath', this.toAppPath)
        location.href = `betterwe://btwx.gymcity.com.cn/?newPath=${encodeURIComponent(
          this.toAppPath
        )}`
      } else {
        if (!this.isIOS) {
          // 安卓 已安装拉起APP询问是否跳转  确定后进入APP首页
          location.href = `betterwe://btwx.gymcity.com.cn/?path=/home`
        } else {
          // IOS 直接进入AppStore 在浏览器 跳转 betterwe:// 链接 没有安装APP时会有报错弹窗
          window.location.href = this.iosAppstoreUrl
        }
      }

      this.showFloat = true
    }
  },

  destroyed() {},

  methods: {
    // 分享
    setShare() {
      let share = {
        // 分享信息
        link: location.href,
        title: '在betterWE星球吃练结合收获好身材',
        desc: '已帮助100w+人成功逆袭，你也快来试试！',
        imgUrl:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png'
      }
      BetterweWxApi.setShareData(share, share)
    },
    // 跳转
    toUrl(index) {
      let routes = ['/agreement', '/privacy-agreement']
      this.$router.push(routes[index])
    },
    // 得到手机系统
    checkPhone() {
      let self = this
      let agent = navigator.userAgent || navigator.vendor || window.opera
      if (agent != null) {
        let agentName = agent.toLowerCase()
        // 安卓判断
        // (/android/i.test(agentName) || /windows|win32/i.test(agentName))
        // ios判断
        if (
          /iphone/i.test(agentName) ||
          /macintosh|mac os x/i.test(agentName)
        ) {
          self.isIOS = true
        } else {
          self.isAndroid = true
        }
      }
      // 配置复制粘贴板
      // this.$nextTick(() => {
      //   this.clipboard = this.inviteCode && new Clipboard(this.$refs.copy)
      // })
    },
    /* 点击下载按钮 */
    downloadApp() {
      if (this.moreInfo == 'ann2024') {
        this.$http.get('member/index?a=shareLogPush', {
          from: `年度报告2024-小红花点击下载`,
          from_id: 20241219
        })
      }
      this.$buryPoint('APP_DOWNLOAD_CLICK', {
        from: this.sfrom
      })
      // 如果配置了粘贴板
      if (this.clipboard) {
        this.clipboard.on('success', () => {
          console.log('====================================')
          console.log('复制成功')
          console.log('====================================')
          this._doDownload()
        })
        this.clipboard.on('error', () => {
          console.log('====================================')
          console.log('复制失败')
          console.log('====================================')
          this._doDownload()
        })
      } else {
        this._doDownload()
      }
    },
    async _doDownload() {
      if (this.isMini) {
        this.$dialog.alert({
          title: '提示',
          message: '请前往手机应用市场搜索“betterWE星球”下载安装'
        })
        return
      }
      if (this.isIOS) {
        //  IOS 直接跳转App Store
        window.location.href = this.iosAppstoreUrl
      } else if (this.isAndroid) {
        // 安卓包下载地址  a
        this.downloadApk(await this.getApk())
      } else {
        this.$toast('暂不支持，敬请期待~')
      }
    },
    async getApk() {
      let url =
        'https://gymvue.gymcity.com.cn/betterWE_channel_BETTERWE.apk'
      try {
        const res = await this.$http.headFile(this.androidDownloadUrl)
        if (res) {
          url = this.androidDownloadUrl 
        }
      } catch (error) {}
      console.log('getApk url', url)
      return url
    },
    downloadApk(url) {
      // 安卓 微信环境
      // this.showOpen = true  // 显示提示遮罩
      // 在微信直接弹窗提示 是否浏览器打开
      if (this.isWeiXin) {
        const a = document.createElement('a')
        url = `https://api3t.gymcity.com.cn/member/downApp?down_url=${encodeURIComponent(
          url
        )}`
        a.href = url
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          document.body.removeChild(a)
        }, 500)
        // 检查下载是否成功触发
        setTimeout(() => {
          // 如果页面仍然可见，说明下载可能未触发 则提示用户手动打开
          if (document.visibilityState === 'visible') {
            this.showOpen = true
          }
        }, 3000)
      } else {
        const a = document.createElement('a')
        let filename = url.split('/')
        filename = filename[filename.length - 1]
        filename = filename.split('.')[0]
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          document.body.removeChild(a)
        }, 500)
      }
    },
    // 从浏览器打开时 直接判断
    identityHash() {
      if (window.location.hash.includes('downloading')) {
        window.location.hash = '' // 还原hash为空
        self.checkPhone()
        if (self.isAndroid) {
          // 安卓，弹出包下载页面
          window.location.href = this.androidDownloadUrl
        } else if (self.isIOS) {
          // ios，直接跳转Appstore
          // this.$toast(this.iosAppstoreUrl)
          window.location.href = this.iosAppstoreUrl
        } else {
          this.$toast('暂不支持，敬请期待~')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.app-download {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  .ad-float {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: vw(67);
    font-size: vw(12);
    background-color: #fff;
    position: fixed;
    bottom: 0;

    a {
      margin-left: vw(19);
      width: 94px;
      height: 28px;
      border-radius: 15px;
      border: 1px solid #3b4761;
      font-weight: 500;
      color: #3b4761;
      border-radius: 99px;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
    }

    a:hover {
    }
  }
  .image-container {
    position: relative;
    min-height: 100vh;
  }
  .ad-open {
    width: 100vw;
    position: absolute;
    top: 0;
    right: 1vw;
  }

  .ad-bg {
    width: 100%;
    box-sizing: border-box;
    display: block;
  }

  .ad-btn {
    width: 327px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1f2021;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12),
      0px 2px 6px 0px rgba(0, 0, 0, 0.14);
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    position: fixed;
    z-index: 88;
    @include fixedBottom(40px);

    img {
      width: vw(27);
      margin-right: vw(12);
      margin-top: vw(-2);
    }
  }

  .ad-btn-img {
    bottom: auto;
    top: vw(673);
    position: absolute;
  }

  .ad-btn-have {
    @include fixedBottom(100px);
  }

  .ad-tips {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    padding: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: vw(12);
    color: rgba($color: #000000, $alpha: 1);
    .t-btn {
      position: relative;
    }
    .t-line {
      width: 0.3vw;
      height: 2.9vw;
      background-color: rgba($color: #000000, $alpha: 0.3);
      margin: 0 2.7vw;
    }
  }

  .ad-tips-jianmeng {
    top: 51.66667vw;
  }
}
.app-download-lrt {
  background-color: #f6f6f6;
  padding-bottom: 1vw;
  padding-bottom: calc(1vw + env(safe-area-inset-bottom));
  padding-bottom: calc(1vw + constant(safe-area-inset-bottom));
}
</style>
